// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-project-manager",
 "roleDisplay": "AI Project Manager",
 "phrase": "ai project manager",
 "seo": {
  "title": "AI Project Manager: Plans, Status, Standups | CellCog",
  "description": "An AI project manager that turns notes into a plan with owners and dates, sits in your standups, files the action items and writes the weekly status update."
 },
 "painSub": "The project isn't late because the work is hard. It's late because nobody had time to chase the updates and write them down. Your AI project manager keeps the plan current and the status honest.",
 "definition": "An AI project manager is an AI employee that builds project plans with milestones and owners, attends standups, turns decisions into action items and writes status updates. On CellCog they are hired in minutes, work alongside tools like Asana, Jira and Linear, and are built on the agent ranked #1 on DeepResearch Bench (October 2026).",
 "panes": [
  {
   "num": "01 · BOARD",
   "title": "Runs the board.",
   "sub": "Tasks, owners and status in one place, updated as work moves.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--board\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Board</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Client site launch</b><span>15 cards, updated after standup</span></div><div class=\"rf-board\"><div class=\"rf-col\"><div class=\"rf-col-h\"><span class=\"rf-dot rf-tone-graphite\"></span><span>To do</span><em>5</em></div><div class=\"rf-card\"><b>Redirects from the old site</b></div><div class=\"rf-card\"><b>Write 404 and empty states</b></div><div class=\"rf-card\"><b>Accessibility pass</b></div><div class=\"rf-card\"><b>Analytics on key pages</b></div><div class=\"rf-card\"><b>Cookie banner copy</b></div></div><div class=\"rf-col\"><div class=\"rf-col-h\"><span class=\"rf-dot rf-tone-blue\"></span><span>In progress</span><em>3</em></div><div class=\"rf-card\"><b>Pricing page</b><span>Jonah</span></div><div class=\"rf-card\"><b>Migrate blog posts</b><span>38 of 60</span></div><div class=\"rf-card\"><b>Contact form</b><span>Lea</span></div></div><div class=\"rf-col\"><div class=\"rf-col-h\"><span class=\"rf-dot rf-tone-amber\"></span><span>Waiting on you</span><em>2</em></div><div class=\"rf-card is-you\"><b>Approve homepage copy</b></div><div class=\"rf-card is-you\"><b>Pick the hero photo</b></div></div><div class=\"rf-col\"><div class=\"rf-col-h\"><span class=\"rf-dot rf-tone-green\"></span><span>Done</span><em>5</em></div><div class=\"rf-card\"><b>Sitemap and wireframes</b></div><div class=\"rf-card\"><b>Design system</b></div><div class=\"rf-card\"><b>Staging site live</b></div><div class=\"rf-card\"><b>Kickoff notes sent</b></div><div class=\"rf-card\"><b>Content inventory</b></div></div></div></div></div></div>"
  },
  {
   "num": "02 · TIMELINE",
   "title": "Keeps the timeline honest.",
   "sub": "Milestones and dates, with slips flagged early instead of at the deadline.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--timeline\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Timeline</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Launch plan</b><span>On track for Nov 12</span></div><div class=\"rf-panel\"><div class=\"rf-tl\" style=\"--n:6\"><div class=\"rf-tl-row rf-tl-head\"><span></span><span>Oct 5</span><span>Oct 12</span><span>Oct 19</span><span>Oct 26</span><span>Nov 2</span><span>Nov 9</span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">Discovery<em>Done</em></span><span class=\"rf-tl-bar rf-tone-green\" style=\"grid-column:2 / span 1\"></span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">Wireframes<em>Done</em></span><span class=\"rf-tl-bar rf-tone-green\" style=\"grid-column:2 / span 2\"></span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">Visual design<em>Done</em></span><span class=\"rf-tl-bar rf-tone-green\" style=\"grid-column:3 / span 2\"></span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">Build pages<em>In progress</em></span><span class=\"rf-tl-bar rf-tone-blue\" style=\"grid-column:4 / span 3\"></span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">Content migration<em>In progress</em></span><span class=\"rf-tl-bar rf-tone-blue\" style=\"grid-column:5 / span 2\"></span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">Client review<em>Needs you</em></span><span class=\"rf-tl-bar rf-tone-amber\" style=\"grid-column:6 / span 1\"></span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">QA and fixes<em>Up next</em></span><span class=\"rf-tl-bar rf-tone-graphite\" style=\"grid-column:6 / span 2\"></span></div><div class=\"rf-tl-row\"><span class=\"rf-tl-lab\">Launch<em>Nov 12</em></span><span class=\"rf-tl-ms rf-tone-orange\" style=\"grid-column:7\"></span></div></div></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Remembers every decision.",
   "sub": "Briefs, meeting notes and past decisions live in your Drive, so nothing is decided twice.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Birchline</span><i aria-hidden=\"true\">/</i><b>Client launch</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Project brief.docx</span><span class=\"rf-fmeta\">Scope and goals</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Launch checklist.xlsx</span><span class=\"rf-fmeta\">46 items</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Signed statement of work.pdf</span><span class=\"rf-fmeta\">Milestones and dates</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Standup notes</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Standup is 9:15, the client reviews on Thursdays, and nothing ships without Lea&#x27;s QA.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before changing plans.",
   "sub": "New dates, scope changes and reassignments wait for your yes.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Send the weekly update to the client?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/gmail\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Helena Ortiz</em></div><b class=\"rf-prev-t\">Launch update, week of Oct 19</b><p class=\"rf-prev-b\">Pages are 70% built and content migration is on track. We need homepage copy approved by Thursday to keep the Nov 12 date.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Move the QA review to Tuesday</span><span class=\"rf-q-m\">Calendar · 3 people</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Nudge Jonah on the pricing page</span><span class=\"rf-q-m\">Slack · drafted</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Writes the status update.",
   "sub": "What shipped, what is blocked and what is next, drafted for your review.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Client site launch</b><span>Today, 5:20 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>13</b><span>cards moved</span></div><div class=\"rf-stat\"><b>70%</b><span>pages built</span></div><div class=\"rf-stat\"><b>2</b><span>waiting on you</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Ran standup and updated the board</li><li>Moved the blog migration to 38 of 60</li><li>Flagged the copy approval risk early</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Send the weekly update to the client</li><li>Book QA with Lea for next week</li><li>Prepare redirects from the old site</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Approve the homepage copy by Thursday</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Builds the project plan",
   "body": "Phases, milestones, owners and dependencies from your notes and task lists."
  },
  {
   "title": "Attends standups",
   "body": "Joins Google Meet, Zoom or Microsoft Teams, answers the status questions you allow and files the action items."
  },
  {
   "title": "Turns decisions into tasks",
   "body": "What was agreed in a meeting lands on the board with an owner and a date."
  },
  {
   "title": "Writes status updates",
   "body": "A weekly update for stakeholders, drafted for your review."
  },
  {
   "title": "Keeps a risk list",
   "body": "Likelihood, impact and a mitigation for each risk, updated as the project moves."
  },
  {
   "title": "Updates your tracker",
   "body": "Reads and updates Asana, Jira or Linear, so the tracker stays the system of record."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a project manager for our website redesign. Launch is in eight weeks.\""
  },
  {
   "n": "02",
   "title": "Connect your tracker.",
   "body": "Add Asana, Jira, Linear or Notion, and invite your AI project manager to the standup."
  },
  {
   "n": "03",
   "title": "Approve the plan.",
   "body": "They send a plan with owners and dates. You change what you want and approve."
  }
 ],
 "tools": [
  {
   "name": "Asana",
   "logo": "https://logos.composio.dev/api/asana"
  },
  {
   "name": "Jira",
   "logo": "https://logos.composio.dev/api/jira"
  },
  {
   "name": "Linear",
   "logo": "https://logos.composio.dev/api/linear"
  },
  {
   "name": "Notion",
   "logo": "https://logos.composio.dev/api/notion"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  },
  {
   "name": "Google Meet",
   "logo": "https://logos.composio.dev/api/googlemeet"
  },
  {
   "name": "Zoom",
   "logo": "https://logos.composio.dev/api/zoom"
  },
  {
   "name": "Google Sheets",
   "logo": "https://logos.composio.dev/api/googlesheets"
  }
 ],
 "control": {
  "statement": "Plans change only with your yes.",
  "sub": "They run the process.",
  "accent": "You make the trade-offs.",
  "rows": [
   {
    "title": "Dates and scope stay yours",
    "body": "New deadlines and scope changes wait for your approval."
   },
   {
    "title": "Asks before reassigning",
    "body": "They update tasks you allow and check before moving anyone's work."
   },
   {
    "title": "Everything visible",
    "body": "Every task, decision and update sits on one board you can read any time."
   }
  ]
 },
 "wont": {
  "sub": "They run the project.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No commitments in meetings",
    "body": "They defer new dates and scope to you."
   },
   {
    "title": "No moving other people's work",
    "body": "They update tasks you allow and ask before reassigning anything."
   },
   {
    "title": "No camera on calls",
    "body": "They join Google Meet, Zoom and Microsoft Teams with the camera off."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to run a project",
  "cols": [
   "Doing it yourself",
   "A project tool alone",
   "AI Project Manager"
  ],
  "rows": [
   {
    "label": "Keeps the plan current",
    "cells": [
     "You, weekly",
     "What people remember to update",
     "After every change"
    ]
   },
   {
    "label": "Attends standups",
    "cells": [
     "You",
     "No",
     "Takes notes, files actions"
    ]
   },
   {
    "label": "Writes the status update",
    "cells": [
     "You",
     "Dashboards only",
     "Drafted for your review"
    ]
   },
   {
    "label": "Flags slips early",
    "cells": [
     "When noticed",
     "Overdue badges",
     "Before the deadline"
    ]
   },
   {
    "label": "Chases updates",
    "cells": [
     "You",
     "Reminders",
     "Yes"
    ]
   },
   {
    "label": "Changes dates or scope",
    "cells": [
     "You",
     "You",
     "Only with your yes"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Turn this messy task list and these meeting notes into a project plan with phases, milestones, owners, dependencies, and a one-page status report.",
   "deliverable": "a project plan and a status report"
  },
  {
   "q": "Build a risk register for our product launch: top 10 risks, likelihood, impact, and a mitigation for each.",
   "deliverable": "a risk register"
  },
  {
   "q": "Write a stakeholder update for this week: what shipped, what is blocked, and what is next, in a clear executive tone.",
   "deliverable": "a ready-to-send status update"
  },
  {
   "q": "Create a project brief for our website redesign with scope, goals, timeline, and success metrics.",
   "deliverable": "a project brief PDF"
  },
  {
   "q": "Turn our roadmap into a visual timeline I can present, with phases and key dates.",
   "deliverable": "a timeline slide for presenting"
  }
 ],
 "faq": [
  {
   "q": "What is an AI project manager?",
   "a": "An AI project manager is an AI employee that builds project plans with milestones and owners, attends standups, turns decisions into action items and writes status updates."
  },
  {
   "q": "Can they attend our standups?",
   "a": "Yes. Invite them to Google Meet, Zoom or Microsoft Teams and they join under their own name, answer status questions you have authorized, defer anything that commits a date or scope, and file the action items after."
  },
  {
   "q": "Do we still need Asana or Jira?",
   "a": "Yes. Your tracker stays the system of record. Your AI project manager reads and updates the tools you connect and turns their data into plans, reports and risk lists."
  },
  {
   "q": "How do they keep the plan current?",
   "a": "Your AI project manager reads new tasks, notes and meeting decisions as they come in and updates the plan and the status report, then tells you what moved."
  },
  {
   "q": "What does AI project management look like day to day?",
   "a": "A plan that updates itself, a standup summary in your inbox, a weekly stakeholder update drafted for your review, and a risk list that flags slips early."
  },
  {
   "q": "Who owns the outcome?",
   "a": "You do. They run the process and the paperwork; the trade-offs and the final calls stay with you."
  },
  {
   "q": "Are they an AI project manager agent or a tool?",
   "a": "An agent. Your project tool holds the tasks; your AI project manager keeps them current, attends standups, chases owners and writes the status update."
  },
  {
   "q": "Is an AI project manager a good fit for a small team?",
   "a": "Yes. Small teams use them so nobody has to own status: your AI project manager keeps the plan current, files the action items and writes the weekly update."
  },
  {
   "q": "Can I try an AI project manager for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI project manager and try a first task."
  },
  {
   "q": "What does an AI project manager cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Project Manager in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Project Manager to work today",
  "body": "Give them your task list and meeting notes and get back a clean project plan with owners and a status report."
 },
 "audience": {
  "title": "Who hires an AI project manager",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "Projects that keep moving",
    "body": "Plans, owners and deadlines kept current without a weekly status chase."
   },
   {
    "badge": "Small businesses",
    "title": "One owner for status",
    "body": "Standups attended, action items filed and the status update written, so nobody has to own the busywork."
   },
   {
    "badge": "Mid-size companies",
    "title": "Status across teams",
    "body": "Plans, risks and weekly updates kept current across projects, in the tools your teams already use."
   },
   {
    "badge": "Agencies",
    "title": "Every client project on track",
    "body": "A plan, a risk list and a weekly update for each client, in one place."
   },
   {
    "badge": "Software teams",
    "title": "Standups turned into action",
    "body": "Your AI project manager joins standups, files the action items in Jira or Linear and writes the release status."
   },
   {
    "badge": "Marketing and launch teams",
    "title": "Launches tracked to the date",
    "body": "A launch plan with owners and deadlines, followed up every week until it ships."
   }
  ]
 }
};

export default content;
